<style lang="scss">
th.sortable {
  cursor: pointer;
}

th.sortable i.right {
  margin-left: 10px;
}

th.table-header.sortable.active {
  background: #ffffff !important;
}

[type='checkbox'] + label {
  pointer-events: auto;
}

.custom-datepicker {
  input[readonly='readonly'] {
    color: #000000 !important;
    border-bottom-width: 1px !important;
    border-bottom-style: solid !important;
    border-bottom-color: #9e9e9e;
  }

  input[readonly='readonly']:focus {
    border-color: #26a69a !important;
    box-shadow: 0 1px 0 0 #26a69a;
  }
}

.custom-datepicker .errorMsg {
  color: red;
  margin: 0;
  font-size: 12px;
}

.v-text-field.custom-select {
  position: relative;
  .v-menu__content {
    top: 35px;
    left: 0;
  }
}

.v-text-field.custom-search {
  .v-text-field__slot input {
    border-bottom: none;
    padding: 5px 12px;
    margin-bottom: 0;
  }

  .v-text-field__slot input:focus {
    border-bottom: none !important;
    box-shadow: none !important;
  }

  .v-label {
    padding: 0 12px;
    top: 12px;
  }
}

.v-menu {
  .v-menu__content {
    top: 0 !important;
    left: 0 !important;
  }
}

.error {
  background-color: #b03236 !important;
  border-color: #b03236 !important;
}

.primary {
  background-color: #3f51b5 !important;
  border-color: #3f51b5 !important;
}

@media only screen and (max-width: 992px) {
  table tr td *,
  table tr th {
    font-size: 0.8em;
  }
}
</style>

<template lang="pug">
.main-content-padded.main-content-nopad-small
  .row
    .col.s12
      .bcrumb
        a(href='#', @click='resetShopper') Shopper
        a(v-if='shopperNew && shopperNew.new') New
    .col.s12(v-if='shopperNew && shopperNew.new')
      form(@submit='submitForm', @change='changeInput')
        //- pre {{shoppers}}
        .row
          .col.s12.m6.input-field
            input#firstName.validate(
              type='text',
              v-model='shopperData.firstName',
              placeholder='ex. John',
              name='firstName',
              :class='{ invalid: hasError("firstName") }'
            )
            p.errorMsg(v-if='errors.firstName') {{ errors.firstName }}
            label.active(for='firstName') First Name *
          .col.s12.m6.input-field
            input#lastName.validate(
              type='text',
              v-model='shopperData.lastName',
              placeholder='ex. Doe',
              name='lastName',
              :class='{ invalid: hasError("lastName") }'
            )
            p.errorMsg(v-if='errors.lastName') {{ errors.lastName }}
            label.active(for='lastName') Last Name *
        .row
          .col.s12.m6.input-field
            //- input#phoneNumber.validate(
            //-   type='number',
            //-   v-model='shopperData.phoneNumber',
            //-   placeholder='XXX XXX XXXX',
            //-   :class='{ invalid: hasError("phoneNumber") }'
            //- )
            the-mask#contact(
              mask='+63 ### ### ####',
              placeholder='+63 ### ### ####',
              v-model='shopperData.phoneNumber',
              :class='{ invalid: hasError("phoneNumber") }'
            )
            p.errorMsg(v-if='errors.phoneNumber') {{ errors.phoneNumber }}
            label.active(for='phoneNumber') Phone Number *
          //- .col.s12.m6.input-field
          //-     input#birthday.bdate(type='text', v-model='shopperData.birthday'  placeholder='YYYY-MM-DD'  name='birthday', ref='bdate' )
          //-     label.active(for='birthday') Birthday *
          .col.s12.m6.input-field
            datepicker#birthday.custom-datepicker(
              v-model='shopperData.birthday',
              name='birthday',
              @input='changeDate',
              :input-class='{ valid: isValid("birthday"), invalid: hasError("birthday") }',
              :disabled-dates='disabledDates',
              :open-date='openDate'
            )
            p.errorMsg(v-if='errors.birthday') {{ errors.birthday }}
            label.active(for='birthday') Birthday *

        .row
          .col.s12.m6.input-field
            input#email.validate(
              type='email',
              v-model='shopperData.email',
              placeholder='ex. john.doe@gmail.com',
              name='email',
              :class='{ invalid: hasError("email") }'
            )
            p.errorMsg(v-if='errors.email') {{ errors.email }}
            label.active(for='email') Email *
          .col.s12.m6.input-field
            input#username.validate(
              type='text',
              v-model='shopperData.username',
              name='username',
              :class='{ invalid: hasError("username") }'
            )
            p.errorMsg(v-if='errors.username') {{ errors.username }}
            label.active(for='username') Username *
        .row
          .col.s12.right-align
          // a.btn.indigo.waves-effect(v-on:click='register') Register
          button.btn.indigo.waves-effect(type='submit') Register
    .col.s12.mt-5(v-else)
      v-app
        v-card
          v-card-title
            v-spacer
            v-text-field.sampleclass(
              v-model='search',
              append-icon='search',
              label='Search',
              single-line='',
              hide-details=''
            )
          v-data-table(
            :headers='headers',
            :items='formatedShopper',
            :pagination.sync='pagination',
            :loading='isLoading',
            :search='search',
            prev-icon='arrow_left',
            next-icon='arrow_right',
            sort-icon='arrow_drop_up'
          )
            v-progress-linear(v-slot='progress', color='blue', indeterminate)
            template(v-slot:items='props')
              td {{ props.item.name }}
              td.text-xs-left {{ props.item.email }}
              td.text-xs-left {{ props.item.username }}
              td.text-xs-left {{ props.item.birthday | date }}
              td.text-xs-left {{ props.item.date | date }}

    a.btn-floating.btn-large.waves-effect.waves-light.indigo.bottom-right(
      @click='newshopper',
      v-if='shopperNew === null'
    )
      i.material-icons add
</template>
<script>
import Appshopper from '@/components/app-reseller'
import axios from 'axios'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'

export default {
  meta: {
    title: 'Members',
  },
  data() {
    return {
      shoppers: [],
      sortField: 'createdAt',
      toggleSort: true,
      showshopper: false,
      shopperNew: null,
      shopper: null,
      shopperIndex: null,
      availableStatus: ['approved', 'application', 'disabled'],
      shopperData: {
        email: null,
        firstName: null,
        lastName: null,
        birthday: null,
        phoneNumber: null,
        username: null,
        type: 'customer',
      },
      // errors: {
      //   email: null,
      //   firstName: null,
      //   lastName: null,
      //   birthday: null,
      //   phoneNumber: null,
      //   username: null,
      // },
      headers: [
        { text: 'Name', value: 'name', width: '20%' },
        { text: 'Email', value: 'email', width: '30%' },
        { text: 'Username', value: 'username', width: '20%' },
        { text: 'Birthday', value: 'birthday', width: '15%' },
        { text: 'Date Registered', value: 'createdAt', width: '15%' },
      ],
      search: '',
      pagination: {
        rowsPerPage: 10,
        totalItems: null,
        descending: true,
        sortBy: 'createdAt',
      },
      isLoading: false,
      totalItems: 0,
    }
  },
  mounted() {
    this.getshoppers()
    const maxDate = new Date(Date.now() - 567648000000) // 18 years old;
    this.$M.Datepicker.init(this.$refs.bdate, {
      yearRange: [maxDate.getFullYear() - 100, maxDate.getFullYear()],
      maxDate: maxDate,
      defaultDate: maxDate,
      format: 'mmm dd, yyyy',
    })
  },
  watch: {
    '$route.query'() {
      this.getshoppers()
    },
    pagination: {
      handler() {
        this.getshoppers()
      },
      deep: true,
    },
  },
  filters: {
    date: function (val) {
      return moment(val).format('MMM DD, YYYY')
      // return moment(val).format('MMM DD, YYYY, h:mm:ss a')
    },
  },
  computed: {
    sortedshoppers() {
      return this.shoppers.sort(this.sortFunction)
    },
    formatedShopper() {
      return this.shoppers.map((shopper) => {
        let newShopper = {
          name: shopper.account.firstName + ' ' + shopper.account.lastName,
          email: shopper.account.email,
          username: shopper.username,
          birthday: shopper.account.birthday,
          createdAt: shopper.account.createdAt,
        }
        this.isLoading = false
        return newShopper
      })
    },
    selectedStatus() {
      return !this.$route.query.status
        ? []
        : typeof this.$route.query.status === 'string'
        ? [this.$route.query.status]
        : this.$route.query.status
    },
    hasError() {
      return (key) => {
        if (this.errors[key] !== null) return !!this.errors[key]
      }
    },
    isValid() {
      return (key) => {
        if (key === 'birthday' && this.errors[key] === null) {
          return !!this.shopperData[key]
        }
      }
    },
    checkShopperData() {
      return Object.values(this.shopperData).some(
        (data) => data === null || data === ''
      )
    },
    checkErrors() {
      return Object.values(this.errors).some((err) => err !== null)
    },
    disabledDates() {
      let to = new Date()
      let from = new Date(to.getFullYear() - 18, to.getMonth(), to.getDate())
      return { from }
    },
    openDate() {
      let dateNow = new Date()
      let datePast = new Date(
        dateNow.getFullYear() - 18,
        dateNow.getMonth(),
        dateNow.getDate()
      )
      return datePast
    },
  },
  methods: {
    updateStatusFilter(e) {
      const selectedStatus = this.selectedStatus.splice()
      const index = this.selectedStatus.indexOf(e.target.value)
      if (e.target.checked && index === -1) {
        selectedStatus.push(e.target.value)
      } else if (!e.target.checked && index !== -1) {
        selectedStatus.splice(index, 1)
      }

      let query = {
        ...this.$route.query,
        status: selectedStatus,
      }
      this.$router.push({
        name: 'shopper',
        query: query,
      })
    },
    resetShopper() {
      this.shopperNew = null
      this.shopperIndex = null
      this.shopperData = {
        email: null,
        firstName: null,
        lastName: null,
        birthday: null,
        phoneNumber: null,
        username: null,
      }
    },
    onshopperCreated(shopper) {
      this.shopper = shopper
      this.shoppers.push(shopper)
    },
    onshopperUpdated(shopper) {
      if (this.shopper.id === shopper.id) {
        this.shopper = shopper
        this.shoppers.splice(this.shopperIndex, 1, shopper)
      }
    },
    newshopper() {
      this.shopperNew = {
        new: true,
      }
    },
    showshopperDetails(index) {
      this.shopper = this.shoppers[index]
      this.shopperIndex = index
    },
    // sortFunction (orderA, orderB) {
    //   const fieldA = orderA[this.sortField]
    //   const fieldB = orderB[this.sortField]
    //   let result = fieldA === fieldB ? 0 : !fieldA && !!fieldB ? 1 : !!fieldA && !fieldB ? -1 : fieldA.toLowerCase() < fieldB.toLowerCase() ? -1 : fieldA.toLowerCase() === fieldB.toLowerCase() ? 0 : 1
    //   return this.toggleSort ? result * -1 : result
    // },
    // sortFunction(orderA, orderB) {
    //   const fieldA = orderA[this.sortField];
    //   const fieldB = orderB[this.sortField];
    //   let result =
    //     fieldA === fieldB
    //       ? 0
    //       : !fieldA && !!fieldB
    //       ? 1
    //       : !!fieldA && !fieldB
    //       ? -1
    //       : fieldA.toLowerCase() < fieldB.toLowerCase()
    //       ? -1
    //       : fieldA.toLowerCase() === fieldB.toLowerCase()
    //       ? 0
    //       : 1;

    //   return this.toggleSort ? result * -1 : result;
    // },
    sortFunction(orderA, orderB) {
      let fieldA = '',
        fieldB = ''
      if (this.sortField === 'name') {
        fieldA = orderA.account['firstName'] + ' ' + orderA.account['lastName']
        fieldB = orderB.account['firstName'] + ' ' + orderB.account['lastName']
      } else if (this.sortField === 'username') {
        fieldA = orderA[this.sortField]
        fieldB = orderB[this.sortField]
      } else if (this.sortField === 'bday') {
        fieldA = orderA.account['birthday']
        fieldB = orderB.account['birthday']
      } else {
        fieldA = orderA.account[this.sortField]
        fieldB = orderB.account[this.sortField]
      }

      let result =
        fieldA === fieldB
          ? 0
          : !fieldA && !!fieldB
          ? 1
          : !!fieldA && !fieldB
          ? -1
          : fieldA.toLowerCase() < fieldB.toLowerCase()
          ? -1
          : fieldA.toLowerCase() === fieldB.toLowerCase()
          ? 0
          : 1
      return this.toggleSort ? result * -1 : result
    },
    setSortingField(sortField) {
      if (this.sortField === sortField) {
        this.toggleSort = !this.toggleSort
      }
      this.sortField = sortField
    },
    getshoppers() {
      this.isLoading = true
      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        let params = {
          sortby: sortBy,
          sorting: descending ? 'DESC' : 'ASC',
          page: page,
        }
        axios
          .get(`${this.$config.API_URL}/admin/customer-sorted-list`, {
            params,
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          })
          .then((result) => {
            this.shoppers = result.data.accounts
            this.totalItems = result.data.totalItems
            this.pagination.totalItems = result.data.totalItems
          })
      })
    },
    register() {
      const getSemail = this.shoppers.find(
        (semail) => semail.account.email === this.shopperData.email
      )
      if (getSemail) {
        this.$snackbar.show({ text: 'Email is already taken.' })
        // } else if (this.shopperData.email === null) {
        //   this.$snackbar.show({ text: 'Please fill out the form.' })
      } else if (this.checkShopperData) {
        this.$snackbar.show({ text: 'Please fill out the form.' })
      } else if (this.checkErrors) {
        this.$snackbar.show({ text: 'Please fill out the form correctly.' })
      } else {
        this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
          axios
            .post(
              `${this.$config.API_URL}/admin/customer-register`,
              this.shopperData,
              {
                headers: {
                  Authorization: `Bearer ${accessToken}`,
                },
              }
            )
            .then((result) => {
              this.$snackbar.show({ text: 'Member Successfully added!' })
              this.resetShopper()
              this.getshoppers()
            })
            .catch((err) => {
              this.$snackbar.show({
                text: err.response.data.errors[0].messages[0],
              })
            })
        })
      }
    },
    submitForm(e) {
      e.preventDefault()
      for (var key in this.shopperData) {
        if (this.shopperData[key] === null || this.shopperData[key] === '')
          this.errors[key] = 'This field is required'
        else if (
          key === 'phoneNumber' &&
          this.shopperData[key] !== null &&
          this.shopperData[key].length !== 10
        )
          this.errors[key] = 'Invalid phone number'
        else this.errors[key] = null
      }
      this.register()
    },

    changeInput(e) {
      e.preventDefault()
      const key = e.target.name
      if (this.shopperData[key] === null || this.shopperData[key] === '')
        this.errors[key] = 'This field is required'
      else this.errors[key] = null
      // for (var key in this.shopperData) {
      //   if (this.shopperData[key] === null || this.shopperData[key] === "")
      //     this.errors[key] = "This field is required";
      //   else
      //     this.errors[key] = "";
      // }
    },

    changeDate(e) {
      // const key = document.querySelector("#birthday").name;
      if (
        this.shopperData.birthday === null ||
        this.shopperData.birthday === ''
      )
        this.errors.birthday = 'This field is required'
      else this.errors.birthday = null
    },
  },
  components: {
    Appshopper,
    Datepicker,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/page-shopper.vue